import Avatar from '@/components/ui/avatar';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/_shadcn-ui/tooltip';
import { memo } from 'react';
import { TTicketMember } from '../../../types/ticket.type';

// Component to render member option in dropdown
type MemberOptionProps = {
  option: TTicketMember | null;
};
const MemberOption = memo(({ option }: MemberOptionProps) => {
  return (
    <div className="flex items-center gap-[8px]">
      <Avatar
        imgSrc={option?.profileImage || ''}
        username={option?.fullname || ''}
        className="w-[17px] h-[17px]"
        classNamePlaceholder="text-[7px]"
      />
      <span className="text-[12px] font-[400] text-[#25151E]">{option?.fullname || ''}</span>
    </div>
  );
});
MemberOption.displayName = 'MemberOption';

// Component to render selected member item
type SelectedMemberItemProps = {
  option: TTicketMember | null;
  onRemove: (option: TTicketMember | null) => void;
};
const SelectedMemberItem = memo(({ option, onRemove }: SelectedMemberItemProps) => {
  return (
    <div className="flex items-center gap-[8px] border border-[#0C8DBF] bg-[#E4F8FF] px-[4px] py-[2px] relative rounded-[4px]">
      <Avatar
        imgSrc={option?.profileImage || ''}
        username={option?.fullname || ''}
        className="w-[17px] h-[17px]"
        classNamePlaceholder="text-[7px]"
      />
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="text-[12px] font-[400] text-[#25151E]">{(option?.fullname || '').slice(0, 11)}...</span>
        </TooltipTrigger>
        <TooltipContent className="z-[100001] bg-white text-[#25151E] text-[12px] font-normal p-2 rounded-lg border">
          <span className="text-[12px] font-[400] text-[#25151E]">{option?.fullname || ''}</span>
        </TooltipContent>
      </Tooltip>
      <div
        onClick={(e) => {
          e.stopPropagation();
          onRemove(option);
        }}
        className="hover:opacity-70 cursor-pointer ml-1"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M10.5 3.5L3.5 10.5" stroke="#0C8DBF" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3.5 3.5L10.5 10.5" stroke="#0C8DBF" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  );
});
SelectedMemberItem.displayName = 'SelectedMemberItem';

export { MemberOption, SelectedMemberItem };
